import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import * as $ from 'jquery';
import { GeolocationService } from 'src/app/core/services/geolocation/geolocation.service';
import { SalePoint } from 'src/app/interfaces/salePoints.interface';

@Component({
  selector: 'app-address-map',
  templateUrl: './address-map.component.html',
  styleUrls: ['./address-map.component.scss'],
})
export class AddressMapComponent implements OnInit {
  @Input() salePoints: SalePoint[];
  @Input() pointGPS: { lat: number; lng: number } | null = null;
  @Input() address: any;
  @Output() salePointData = new EventEmitter();
  mapCenter: { lat: number; lng: number } | null = null;
  marker = {
    options: {
      icon: '../../../../assets/imgs/img-address/casa-mapa.png',
    },
  };
  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;

  constructor(private geolocationService: GeolocationService) { }

  ngOnInit(): void {
    this.mapCenter = this.pointGPS ? { ...this.pointGPS } : null;
  }

  /**
   * Update the location of point according to the map
   */
  changeCenter(event: google.maps.MapMouseEvent) {
    const latLng = event?.latLng;
    if (!latLng) return;

    const lat = latLng.lat();
    const lng = latLng.lng();

    this.mapCenter = { lat, lng };
  }

  /**Validate the position in the map */
  async validatePosition() {
    let res: any;
    if (this.address.ciudad && this.address.ciudad.includes('Rodadero')) {
      let rodaderoSalePoint = this.salePoints.filter(sp => sp.nombre.includes('Rodadero'))[0];
      res = { coverage: true, salePointInfo: rodaderoSalePoint }
    } else {
      console.log("puntos GPS", this.pointGPS)
      console.log("puntos GPS", this.salePoints)
      if (!this.mapCenter) return;
      res = await this.geolocationService
        .validateLocationMap(this.pointGPS, this.salePoints)
        .then((res) => {
          return res;
        })
        .catch((error) => {
          return error;
        });
    }
    res.pointGPS = this.mapCenter;
    console.log("Coverage", res);
    await this.salePointData.emit(res);
    $('#closeMapCovarage')?.click();
  }
}
